<template>
  <AuthLayout :mode="mode">
    <Section
      heading="Cisco Information Clearing House-for Members"
      description="We have set up this section of the ITAD Association Web site as a place for <br class='sm:hidden' /> Members to share information about CISCO products and the CISCO Market."
      :mode="mode"
    />
    <AppCard :mode="mode">
      <template #body>
        <div class="flex flex-col gap-6 sm:gap-4">
          <div
            class="border-b pb-6 sm:pb-5"
            :class="[
              mode === 'dark' ? 'border-dark-border' : 'border-border-10',
            ]"
          >
            <h2
              class="mb-5 text-[22px] font-semibold leading-none sm:text-[18px] sm:leading-[1.4]"
            >
              Counterfeit and Stolen CISCO Product and COUNTERFEIT INDICATORS
            </h2>
            <div class="grid gap-2">
              <p
                class="text-[14px] font-medium"
                :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-60']"
              >
                The ASCDI shares counterfeit indicators on CISCO equipment that
                we receive from our members in an effort to shut down the
                trafficing in fraudulent products. We encourage our members to
                share as much information as they can about counterfeit product
                for the good of our Industry.
              </p>
              <p
                class="text-[14px] font-medium"
                :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-60']"
              >
                If you suspect you have received counterfeit CISCO products,
                please contact the ASCDI Office and we will compare your
                information with our database of counterfeit indicators. Below
                are some CISCO Counterfeit indicators.
              </p>
              <ul
                class="grid list-disc gap-1 pl-4 text-[14px] font-medium text-primary-100"
              >
                <li>
                  <a
                    href="https://www.ascdi.com/wp-content/uploads/2023/09/CISCOGBICHOLOGRAM082011.pdf"
                    >CISCO HOLOGRAM for newer G-GIC's turns from Gold to
                    Green</a
                  >
                </li>
                <li>
                  <a
                    href="https://www.ascdi.com/wp-content/uploads/2023/09/CISCOGBICLEADS.pdf"
                    >CISCO GBIC LEADS don’t look right</a
                  >
                </li>
                <li>
                  <a
                    href="https://www.ascdi.com/wp-content/uploads/2023/09/CISCOGBICpink.pdf"
                    >Packaging- The counterfeit have a clear bag with a static
                    sticker package for the G-BIC. They should have the pink
                    static bag with no static sticker.</a
                  >
                </li>
                <li>
                  <a
                    href="https://www.ascdi.com/wp-content/uploads/2023/09/CISCOGBICPRINTING.pdf"
                    >The printing on the G-BIC brings a red flag –The CISCO
                    label on the G-BIC is to bold</a
                  >
                </li>
                <li>
                  <a
                    href="https://www.ascdi.com/wp-content/uploads/2023/09/CISCOGBICSTRAIGHT.pdf"
                    >CISCO GBIC LABEL is not straight</a
                  >
                </li>
                <li>
                  <a
                    href="https://www.ascdi.com/wp-content/uploads/2023/09/CISCOGBICCONNECTORS.pdf"
                    >CONNETORS-The connectors are brown color not a gold
                    color</a
                  >
                </li>
              </ul>
            </div>
          </div>
          <div
            class="border-b pb-6 sm:pb-5"
            :class="[
              mode === 'dark' ? 'border-dark-border' : 'border-border-10',
            ]"
          >
            <h2
              class="mb-5 text-[22px] font-semibold leading-none sm:text-[18px] sm:leading-[1.4]"
            >
              CISCO Policies
            </h2>
            <div class="grid gap-2">
              <ul
                class="grid list-disc gap-1 pl-4 text-[14px] font-medium text-primary-100"
              >
                <li>
                  <a
                    href="https://www.ascdi.com/wp-content/uploads/2025/03/CISCO-support-reinstatement-policy.pdf"
                    >CISCO support reinstatement policy
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.ascdi.com/wp-content/uploads/2025/03/Cisco-Hardware-Inspection-and-Software-Relicensing-Program-Cisco.pdf"
                    >Cisco Hardware Inspection and Software Relicensing
                    Program</a
                  >
                </li>
                <li>
                  <a
                    href="http://www.cisco.com/en/US/products/products_end-of-life_policy.html"
                    >CISCO END OF LIFE POLICY</a
                  >
                </li>
                <li>
                  <a
                    href="http://www.ascdi.com/wp-content/uploads/2015/02/Used-Equip-Playbook1.pdf"
                    >CISCO Used Equipment Playbook</a
                  >
                </li>
                <li>
                  <a
                    href="http://www.ascdi.com/wp-content/uploads/2015/02/Ciscoinspectionpricing.pdf"
                    >CISCO Inspection Pricing</a
                  >
                </li>
                <li>
                  <a
                    href="http://www.ascdi.com/wp-content/uploads/2015/02/cisco-used-equipment-service.pdf"
                    >CISCO Used Equipment Service Policies</a
                  >
                </li>
                <li>
                  <a
                    href="http://www.ascdi.com/wp-content/uploads/2015/02/Smart-Foundation-1.pdf"
                    >Smartnet Foundation Service</a
                  >
                </li>
                <li>
                  <a
                    href="http://www.ascdi.com/wp-content/uploads/2015/02/smartnet04112008.pdf"
                    >Achieving Profitability with Cisco Services</a
                  >
                </li>
              </ul>
            </div>
          </div>
          <div>
            <h2
              class="mb-5 text-[22px] font-semibold leading-none sm:text-[18px] sm:leading-[1.4]"
            >
              CISCO Tools
            </h2>
            <div class="flex flex-col gap-5">
              <div class="flex flex-col gap-2">
                <h3 class="text-[18px] font-semibold">
                  <span>1 - </span> Cisco Technical Assistance Center (TAC)
                </h3>
                <p
                  class="text-[14px] font-medium"
                  :class="[
                    mode === 'dark' ? 'text-dark-text' : 'text-black-60',
                  ]"
                >
                  Save time by having your Cisco Smartnet Contract Number or
                  Serial Number ready
                </p>
                <p
                  class="text-[14px] font-medium"
                  :class="[
                    mode === 'dark' ? 'text-white-100' : 'text-black-80',
                  ]"
                >
                  US phone:
                  <span class="text-primary-100">800-553-2447</span>
                </p>
                <p
                  class="text-[14px] font-medium"
                  :class="[
                    mode === 'dark' ? 'text-white-100' : 'text-black-80',
                  ]"
                >
                  Worldwide Phone Numbers:
                  <a
                    href="http://www.cisco.com/warp/customer/687/Directory/DirTAC.shtml"
                    target="_blank"
                    class="break-words text-primary-100"
                    >http://www.cisco.com/warp/customer/687/Directory/DirTAC.shtml</a
                  >
                </p>
                <p
                  class="text-[14px] font-medium"
                  :class="[
                    mode === 'dark' ? 'text-white-100' : 'text-black-80',
                  ]"
                >
                  Open a Trouble Ticket Online:
                  <a
                    href="http://tools.cisco.com/ServiceRequestTool/create/"
                    target="_blank"
                    class="break-words text-primary-100"
                  >
                    http://tools.cisco.com/ServiceRequestTool/create/</a
                  >
                </p>
                <p
                  class="text-[14px] font-medium"
                  :class="[
                    mode === 'dark' ? 'text-white-100' : 'text-black-80',
                  ]"
                >
                  Query an Existing Case:
                  <a
                    href=" http://tools.cisco.com/ServiceRequestTool/query"
                    target="_blank"
                    class="break-words text-primary-100"
                  >
                    http://tools.cisco.com/ServiceRequestTool/query</a
                  >
                </p>
              </div>
              <div class="flex flex-col gap-2">
                <h3 class="text-[18px] font-semibold">
                  <span>2 - </span> Cisco Product Support
                </h3>
                <p class="text-[14px] font-semibold">
                  Download Software * Easily Find:
                </p>
                <ul
                  class="grid list-disc gap-1 pl-4 text-[14px] font-medium"
                  :class="[
                    mode === 'dark' ? 'text-dark-text' : 'text-black-60',
                  ]"
                >
                  <li>Configure</li>
                  <li>Install</li>
                  <li>Upgrade</li>
                  <li>Maintain</li>
                  <li>Operate & Troubleshoot Guides</li>
                </ul>
                <p
                  class="text-[14px] font-medium"
                  :class="[
                    mode === 'dark' ? 'text-white-100' : 'text-black-80',
                  ]"
                >
                  Website:
                  <a
                    href="http://www.cisco.com/support"
                    target="_blank"
                    class="break-words text-primary-100"
                    >http://www.cisco.com/support</a
                  >
                </p>
              </div>
              <div class="flex flex-col gap-2">
                <h3 class="text-[18px] font-semibold">
                  <span>3 - </span> CISCO PARTNER PRE-SALES SUPPORT
                </h3>
                <p
                  class="text-[14px] font-medium"
                  :class="[
                    mode === 'dark' ? 'text-dark-text' : 'text-black-60',
                  ]"
                >
                  Technical Questions: Open a support case for technical product
                  information and assistance with network design and product
                  selection.
                </p>
                <p
                  class="text-[14px] font-medium"
                  :class="[
                    mode === 'dark' ? 'text-white-100' : 'text-black-80',
                  ]"
                >
                  Website:
                  <a
                    href="http://ciscopartner.esecurecare.net"
                    target="_blank"
                    class="break-words text-primary-100"
                    >http://ciscopartner.esecurecare.net</a
                  >
                </p>
                <p class="text-[14px] font-semibold">
                  Availability: 4am-6pm PST, Monday-Friday — Non-Technical
                  Questions
                </p>
                <ul
                  class="grid list-disc gap-1 pl-4 text-[14px] font-medium"
                  :class="[
                    mode === 'dark' ? 'text-dark-text' : 'text-black-60',
                  ]"
                >
                  <li>Certification</li>
                  <li>Specialization</li>
                  <li>
                    And channel partner tools including access or login issues.
                  </li>
                </ul>
                <p
                  class="text-[14px] font-medium"
                  :class="[
                    mode === 'dark' ? 'text-white-100' : 'text-black-80',
                  ]"
                >
                  Website:
                  <a
                    href="http://www.cisco.com/web/partners/tools/helponline/index.html"
                    target="_blank"
                    class="break-words text-primary-100"
                    >http://www.cisco.com/web/partners/tools/helponline/index.html</a
                  >
                </p>
              </div>
              <div class="flex flex-col gap-2">
                <h3 class="text-[18px] font-semibold">
                  <span>4 - </span> PDI HELP DESK
                </h3>
                <p
                  class="text-[14px] font-medium"
                  :class="[
                    mode === 'dark' ? 'text-dark-text' : 'text-black-60',
                  ]"
                >
                  Advanced Unified Communications design review and
                  recommendations, upgrade and migration plan validation and
                  pre-deployment assistance by top Cisco experts.
                </p>
                <p class="text-[14px] font-semibold">
                  Available only to partners holding selective certifications
                  (ATP, Advanced UC, Express UC, SMB).
                </p>
                <p
                  class="text-[14px] font-medium"
                  :class="[
                    mode === 'dark' ? 'text-white-100' : 'text-black-80',
                  ]"
                >
                  Main Website:
                  <a
                    href="http://www.cisco.com/go/pdihelpdesk"
                    target="_blank"
                    class="break-words text-primary-100"
                    >http://www.cisco.com/go/pdihelpdesk</a
                  >
                </p>
                <p
                  class="text-[14px] font-medium"
                  :class="[
                    mode === 'dark' ? 'text-white-100' : 'text-black-80',
                  ]"
                >
                  Open Case:
                  <a
                    href="http://pdihd.esecurecare.net"
                    target="_blank"
                    class="break-words text-primary-100"
                    >http://pdihd.esecurecare.net</a
                  >
                </p>
                <p
                  class="text-[14px] font-medium"
                  :class="[
                    mode === 'dark' ? 'text-white-100' : 'text-black-80',
                  ]"
                >
                  Telephone: 800-462-4726 or 408-526-4000
                </p>
                <p
                  class="text-[14px] font-medium"
                  :class="[
                    mode === 'dark' ? 'text-white-100' : 'text-black-80',
                  ]"
                >
                  Availability: 7am-9pm EST, Monday-Friday
                </p>
              </div>
              <div class="flex flex-col gap-2">
                <h3 class="text-[18px] font-semibold">
                  <span>5 - </span> RECOMMENDED TOOLS
                </h3>
                <p
                  class="text-[14px] font-medium"
                  :class="[
                    mode === 'dark' ? 'text-white-100' : 'text-black-80',
                  ]"
                >
                  Product Advisor (VERY GOOD):
                  <a
                    href="http://www.ciscowebtools.com/productadvisor"
                    target="_blank"
                    class="break-words text-primary-100"
                    >http://www.ciscowebtools.com/productadvisor</a
                  >
                </p>
                <p
                  class="text-[14px] font-medium"
                  :class="[
                    mode === 'dark' ? 'text-white-100' : 'text-black-80',
                  ]"
                >
                  Dynamic Configurator Tool:
                  <a
                    href="http://www.cisco.com/commarch/html/config-tool"
                    target="_blank"
                    class="break-words text-primary-100"
                    >http://www.cisco.com/commarch/html/config-tool</a
                  >
                </p>
                <p
                  class="text-[14px] font-medium"
                  :class="[
                    mode === 'dark' ? 'text-white-100' : 'text-black-80',
                  ]"
                >
                  Partner Promotions:
                  <a
                    href="http://www.cisco.com/web/partners/sell/promotions/index.html"
                    target="_blank"
                    class="break-words text-primary-100"
                    >http://www.cisco.com/web/partners/sell/promotions/index.html</a
                  >
                </p>
                <p
                  class="text-[14px] font-medium"
                  :class="[
                    mode === 'dark' ? 'text-white-100' : 'text-black-80',
                  ]"
                >
                  Order Status Tool for Direct Orders:
                  <a
                    href="http://tools.cisco.com/qtc/status/tool/action/LoadOrderQueryScreen"
                    target="_blank"
                    class="break-words text-primary-100"
                    >http://tools.cisco.com/qtc/status/tool/action/LoadOrderQueryScreen</a
                  >
                </p>
                <p
                  class="text-[14px] font-medium"
                  :class="[
                    mode === 'dark' ? 'text-white-100' : 'text-black-80',
                  ]"
                >
                  Lead Time Tools for Direct Orders:
                  <a
                    href="http://www.cisco.com/cgi-bin/front.x/leadtimes.cgi"
                    target="_blank"
                    class="break-words text-primary-100"
                    >http://www.cisco.com/cgi-bin/front.x/leadtimes.cgi</a
                  >
                </p>
                <p
                  class="text-[14px] font-medium"
                  :class="[
                    mode === 'dark' ? 'text-white-100' : 'text-black-80',
                  ]"
                >
                  Cisco Capital Leasing Calculator:
                  <a
                    href="http://www.cisco.com/web/ordering/ciscocapital/downloads/Cisco_Capital-Lease_Quoting_Tool.xls"
                    target="_blank"
                    class="break-words text-primary-100"
                    >http://www.cisco.com/web/ordering/ciscocapital/downloads/Cisco_Capital-Lease_Quoting_Tool.xls</a
                  >
                </p>
                <p
                  class="text-[14px] font-medium"
                  :class="[
                    mode === 'dark' ? 'text-white-100' : 'text-black-80',
                  ]"
                >
                  Cisco Capital Hotline: 866-247-2680
                </p>
                <p
                  class="text-[14px] font-medium"
                  :class="[
                    mode === 'dark' ? 'text-white-100' : 'text-black-80',
                  ]"
                >
                  Serial Number Info Finder (SNIF):
                  <a
                    href=" http://www.cisco.com/public/scc"
                    target="_blank"
                    class="break-words text-primary-100"
                    >http://www.cisco.com/public/scc</a
                  >
                </p>
                <p
                  class="text-[14px] font-medium"
                  :class="[
                    mode === 'dark' ? 'text-dark-text' : 'text-black-60',
                  ]"
                >
                  LOGIN, goto Advanced, SNIF
                </p>
              </div>
              <div class="flex flex-col gap-2">
                <h3 class="text-[18px] font-semibold">
                  <span>6 - </span> SMARTNET & WARRANTY
                </h3>
                <p
                  class="text-[14px] font-medium"
                  :class="[
                    mode === 'dark' ? 'text-white-100' : 'text-black-80',
                  ]"
                >
                  Product Warranty:
                  <a
                    href=" http://www.cisco.com/go/warranty"
                    target="_blank"
                    class="break-words text-primary-100"
                  >
                    http://www.cisco.com/go/warranty</a
                  >
                </p>
                <p
                  class="text-[14px] font-medium"
                  :class="[
                    mode === 'dark' ? 'text-white-100' : 'text-black-80',
                  ]"
                >
                  Smart Foundation:
                  <a
                    href="http://www.cisco.com/en/US/products/ps6193/serv_group_home.html"
                    target="_blank"
                    class="break-words text-primary-100"
                    >http://www.cisco.com/en/US/products/ps6193/serv_group_home.html</a
                  >
                </p>
                <p
                  class="text-[14px] font-medium"
                  :class="[
                    mode === 'dark' ? 'text-white-100' : 'text-black-80',
                  ]"
                >
                  SMARTNET:
                  <a
                    href="http://www.cisco.com/go/smartnet"
                    target="_blank"
                    class="break-words text-primary-100"
                    >http://www.cisco.com/go/smartnet</a
                  >
                </p>
              </div>
              <div class="flex flex-col gap-2">
                <h3 class="text-[18px] font-semibold">
                  <span>7 - </span> GREY MARKET, REFURBISHED Equipment
                </h3>
                <p
                  class="text-[14px] font-medium"
                  :class="[
                    mode === 'dark' ? 'text-white-100' : 'text-black-80',
                  ]"
                >
                  Grey Market Issues:
                  <a
                    href="http://www.cisco.com/go/brandprotection/"
                    target="_blank"
                    class="break-words text-primary-100"
                    >http://www.cisco.com/go/brandprotection</a
                  >
                </p>
                <p
                  class="text-[14px] font-medium"
                  :class="[
                    mode === 'dark' ? 'text-white-100' : 'text-black-80',
                  ]"
                >
                  Grey Market Contacts: 877-571-1700 or
                  <a
                    href="brandprotection@cisco.com"
                    target="_blank"
                    class="break-words text-primary-100"
                    >brandprotection@cisco.com</a
                  >
                </p>
                <p
                  class="text-[14px] font-medium"
                  :class="[
                    mode === 'dark' ? 'text-white-100' : 'text-black-80',
                  ]"
                >
                  End-Of-Sale/Life Products & Policy:
                  <a
                    href="http://www.cisco.com/go/eol"
                    target="_blank"
                    class="break-words text-primary-100"
                    >http://www.cisco.com/go/eol</a
                  >
                </p>
                <p
                  class="text-[14px] font-medium"
                  :class="[
                    mode === 'dark' ? 'text-white-100' : 'text-black-80',
                  ]"
                >
                  Refurb site:
                  <a
                    href="http://www.cisco.com/web/ordering/ciscocapital/refurbished/index.html"
                    target="_blank"
                    class="break-words text-primary-100"
                    >http://www.cisco.com/web/ordering/ciscocapital/refurbished/index.html</a
                  >
                </p>
              </div>
              <div class="flex flex-col gap-2">
                <h3 class="text-[18px] font-semibold">
                  <span>8 - </span> DISTRIBUTOR CISCO SUPPORT
                </h3>
                <div class="flex flex-col gap-3">
                  <div class="flex flex-col gap-2">
                    <p class="text-[14px] font-semibold">Techdata</p>
                    <p
                      class="text-[14px] font-medium"
                      :class="[
                        mode === 'dark' ? 'text-white-100' : 'text-black-80',
                      ]"
                    >
                      Pre-Sales Telephone: 888-213-3630
                    </p>
                    <p
                      class="text-[14px] font-medium"
                      :class="[
                        mode === 'dark' ? 'text-white-100' : 'text-black-80',
                      ]"
                    >
                      Cisco SE Team Telephone: (800) 237-8931 x77776
                    </p>
                    <p
                      class="text-[14px] font-medium"
                      :class="[
                        mode === 'dark' ? 'text-white-100' : 'text-black-80',
                      ]"
                    >
                      Cisco SE Team Email:
                      <a
                        href="secisco@techdata.com"
                        target="_blank"
                        class="break-words text-primary-100"
                        >secisco@techdata.com</a
                      >
                    </p>
                    <p
                      class="text-[14px] font-medium"
                      :class="[
                        mode === 'dark' ? 'text-white-100' : 'text-black-80',
                      ]"
                    >
                      Website:
                      <a
                        href="http://www.techdata.com/business/cisco/"
                        target="_blank"
                        class="break-words text-primary-100"
                        >http://www.techdata.com/business/cisco</a
                      >
                    </p>
                  </div>
                  <div class="grid gap-2">
                    <p class="text-[14px] font-semibold">IngramMicro</p>
                    <p
                      class="text-[14px] font-medium"
                      :class="[
                        mode === 'dark' ? 'text-white-100' : 'text-black-80',
                      ]"
                    >
                      Cisco Product Specialist: 800-456-8000, ext. 76471
                    </p>
                    <p
                      class="text-[14px] font-medium"
                      :class="[
                        mode === 'dark' ? 'text-white-100' : 'text-black-80',
                      ]"
                    >
                      Cisco Services Support Desk: (800) 456-8000, ext. 76471
                    </p>
                    <p
                      class="text-[14px] font-medium"
                      :class="[
                        mode === 'dark' ? 'text-white-100' : 'text-black-80',
                      ]"
                    >
                      Cisco Pre-Sales Technical Support: (800) 456-8000, ext.
                      76471
                    </p>
                    <p
                      class="text-[14px] font-medium"
                      :class="[
                        mode === 'dark' ? 'text-white-100' : 'text-black-80',
                      ]"
                    >
                      Website:
                      <a
                        href="http://www.ingrammicro.com/cisco"
                        target="_blank"
                        class="break-words text-primary-100"
                        >http://www.ingrammicro.com/cisco</a
                      >
                    </p>
                  </div>
                  <div class="grid gap-2">
                    <p class="text-[14px] font-semibold">Comstor</p>
                    <p
                      class="text-[14px] font-medium"
                      :class="[
                        mode === 'dark' ? 'text-white-100' : 'text-black-80',
                      ]"
                    >
                      Main Phone Numbers: 888-286-7587
                    </p>
                    <p
                      class="text-[14px] font-medium"
                      :class="[
                        mode === 'dark' ? 'text-white-100' : 'text-black-80',
                      ]"
                    >
                      Log-in Required Website:
                      <a
                        href="http://compass.comstor.com/start.aspx"
                        target="_blank"
                        class="break-words text-primary-100"
                        >http://compass.comstor.com/start.aspx</a
                      >
                    </p>
                    <p
                      class="text-[14px] font-medium"
                      :class="[
                        mode === 'dark' ? 'text-white-100' : 'text-black-80',
                      ]"
                    >
                      General Website:
                      <a
                        href="http://www.comstor.com/cisco/services_070107.html"
                        target="_blank"
                        class="break-words text-primary-100"
                        >http://www.comstor.com/cisco/services_070107.html</a
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </AppCard>
  </AuthLayout>
</template>

<script>
import Section from "@C/Common/Section.vue";
import AppCard from "@C/Common/AppCard.vue";
import AuthLayout from "@A/AuthLayout.vue";

export default {
  name: "CiscoMembers",
  components: {
    AuthLayout,
    Section,
    AppCard,
  },
  props: {
    mode: String,
  },
};
</script>
